import Loader from 'components/Loader';
import useModels from 'api/prompts-models/useModels';
import ModelItem from './ModelItem';
import { useState } from 'react';
import ModelAdd from './ModelAdd';
import ModelEdit from './ModelEdit';
import { useKeyboard } from 'hooks/useKeyboard';
import { useSearchParams } from 'react-router-dom';
import { SettingsSection } from 'components/settingsHub/SettingsSection';
import { AddEntityCard } from 'components/settingsHub/EntityCard';
import { EntityGrid } from 'components/settingsHub/settingsEntities.styles';
import { SettingsDetailPanel } from 'components/settingsHub/SettingsDetailPanel';

const ModelsView = () => {
  const { models, isLoading } = useModels();
  const [addModelFormOpen, setAddModelFormOpen] = useState(false);
  const [editModelId, setEditModelId] = useState<string | null>(null);
  const [search, setSearch] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  useKeyboard({
    keyDown: (e) => {
      if (e.key === 'Escape' && searchParams.get('config')) {
        if (editModelId) {
          setEditModelId(null);
        } else if (addModelFormOpen) {
          setAddModelFormOpen(false);
        } else {
          setSearchParams({});
        }
      }
    },
  });

  if (isLoading) return <Loader />;

  const query = search.trim().toLowerCase();
  const filtered = [...(models ?? [])]
    .sort((a, b) => b.created_at.localeCompare(a.created_at))
    .filter(
      (m) => !query || m.name.toLowerCase().includes(query) || (m.settings?.model ?? '').toLowerCase().includes(query),
    );

  return (
    <>
      <SettingsSection
        search={search}
        onSearchChange={setSearch}
        searchPlaceholder="Search models…"
        count={filtered.length}
        countNoun="models"
      >
        <EntityGrid minTile={260}>
          <AddEntityCard label="Add New Model" onClick={() => setAddModelFormOpen(true)} minHeight={210} />
          {filtered.map((model) => (
            <ModelItem key={model.id} model={model} onSelect={() => setEditModelId(model.id)} />
          ))}
        </EntityGrid>
      </SettingsSection>

      {addModelFormOpen && (
        <SettingsDetailPanel onClose={() => setAddModelFormOpen(false)}>
          <ModelAdd onClose={() => setAddModelFormOpen(false)} />
        </SettingsDetailPanel>
      )}

      {editModelId && (
        <SettingsDetailPanel onClose={() => setEditModelId(null)}>
          <ModelEdit modelId={editModelId} onClose={() => setEditModelId(null)} />
        </SettingsDetailPanel>
      )}
    </>
  );
};

export default ModelsView;
